define(function (require) {
    var $ = require("jquery");
    var ko = require("knockout");
    var _ = require("underscore");

    var controls = {
        get button() {
            return controls.input.siblings("div.bootstrap-select").children("button.dropdown-toggle");
        },
        get container() {
            return controls.input.siblings("div.bootstrap-select").children("div.dropdown-menu");
        },
        get select() {
            return controls.input.siblings("div.bootstrap-select").children("select.bselect");
        },

        input: null,

        hide: function () {
            if (controls.container.is(":visible")) controls.button.click();
        },
        show: function () {
            if (!controls.container.is(":visible")) controls.button.click();
        },
        toggle: function (flag) {
            flag === true ? controls.show() : controls.hide();
        }
    };
    var values = {
        suggestVal: null,
        suggestValOptions: null,
        suggestValThrottled: null
    };
    var config = {
        minTermLength: 3,
        maxResults: 10,
        serviceApi: null,
        serviceApiQueryStringFieldName: null,
        serviceParams: null,
        labelProperty: null,
        resultsProperty: null,
        valueProperty: null,
        noResultsIndicator: null
    };

    var onKeyup = function (event) {
        if (event.altKey || event.ctrlKey) return false;
        if (_.contains([16, 17, 18, 91], event.which)) return false;

        var term = $(event.target).val();

        if (term.length < config.minTermLength) {
            values.suggestVal(null);
            values.suggestValOptions([]);
            controls.hide();
        }
        if (term.length >= config.minTermLength) {
            term === values.suggestVal() ? controls.show() : values.suggestVal(term);
        }

        return true;
    };
    var onShown = function (event) {
        var isUpperCase = function (str) {
            return str === str.toUpperCase();
        };
        var doHighlight = function (i, el) {
            // highlight the matching term in the suggestions
            var $el = $(el);
            var term = values.suggestVal() || "";
            var text = $el.text();
            var regexp = new RegExp(term, "gi");
            // if the existing text is uppercase then do an uppercase replacement (this is primarily
            // for brand drugs in formulary search); otherwise just replace using the same casing
            // as typed into the field by the user.
            var replace = "<strong>" + (isUpperCase(text) ? term.toUpperCase() : term) + "</strong>";
            var html = $el.text().replace(regexp, function (match) {
                return replace;
            });

            $el.html(html);
        };

        controls.container.find("span.text").each(doHighlight);
    };
    var throttledSubscriber = function (term) {
        if (term && term.length >= config.minTermLength) {
            var parameters = config.serviceParams();
            var hideControls = function () {
                values.suggestValOptions([]);
                controls.hide();
            };
            var getResultsDone = function (results) {
                var mapper = function (item) {
                    return {
                        value: item[config.valueProperty],
                        label: item[config.labelProperty]
                    };
                };
                var suggestions = $.map(results[config.resultsProperty], mapper);

                if (config.maxResults > 0) suggestions = suggestions.slice(0, config.maxResults);

                if (suggestions.length === 0) {
                    if (typeof config.noResultsIndicator === "function") {
                        config.noResultsIndicator(true); //needed for HCR Add meds- used to show/hide message
                    }

                    hideControls();
                    return;
                } else {
                    if (typeof config.noResultsIndicator === "function") {
                        config.noResultsIndicator(false); //needed for HCR Add meds- used to show/hide message
                    }
                }

                values.suggestValOptions(suggestions);
                controls.toggle(suggestions.length > 0);
                controls.input.focus();
            };
            var getResultsFail = function () {
                console.log("failed not-so silently!  grrr "); /* fail silently */
            };

            parameters["suggestionsOnly"] = true;
            parameters[config.serviceApiQueryStringFieldName] = term;
            config.serviceApi(parameters).done(getResultsDone).fail(getResultsFail);
        } else {
            if (typeof hideControls === "function") {
                hideControls();
            }
        }
    };

    ko.bindingHandlers.typeahead = {
        init: function (element, valueAccessor, allBindings) {
            var params = valueAccessor();
            var delayTimeout = 3000;
            var delayFlag = true;
            var delayed = function () {
                // set things up here that are dependent on other scripts doing their job first...
                // specifically, waiting for bootstrap dropdown to create/move its pieces.
                // if other items need to be added then use a object with multiple flags.
                // e.g. delayFlags = { selectPickerEventHandlersSet: false, somethingElseSet: false }

                if (!delayFlag || delayFlag !== true || delayTimeout <= 0) return;

                delayFlag = false;
                delayTimeout -= 250;

                controls.select.length == 1 ? controls.select.on("refreshed.bs.select", onShown) : (delayFlag = true);

                setTimeout(delayed, 250);
            };
            var isObservableArray = function (obj) {
                return ko.isObservable(obj) && obj() instanceof Array;
            };

            try {
                if (!params.serviceApi) throw "serviceApi param missing";
                if (!params.serviceApiQueryStringFieldName) throw "serviceApiQueryStringFieldName missing";
                if (!params.serviceParams) throw "serviceParams param missing";
                if (!params.suggestions) throw "suggestions param missing";
                if (!params.resultsPropertyName) throw "resultsPropertyName param is missing";
                if (!params.labelPropertyName) throw "labelPropertyName param is missing";
                if (!params.valuePropertyName) throw "valuePropertyName param is missing";
                // if (!params.noResultsIndicator) throw 'noResultsIndicator param is missing';  // having this in place breaks every place except HCR

                if (!ko.isComputed(params.serviceParams)) throw "serviceParams param is not ko.computed";
                if (!isObservableArray(params.suggestions)) throw "suggestions param is not ko.observableArray";

                config.resultsProperty = params.resultsPropertyName;
                config.labelProperty = params.labelPropertyName;
                config.valueProperty = params.valuePropertyName;
                config.serviceApi = params.serviceApi;
                config.serviceApiQueryStringFieldName = params.serviceApiQueryStringFieldName;
                config.serviceParams = params.serviceParams;
                config.noResultsIndicator = params.noResultsIndicator;

                controls.input = $(element);

                if (controls.input.length == 0) throw "could not find input element from inputSelector param";

                if (params.minimumTermLength && parseInt(params.minimumTermLength)) config.minTermLength = params.minimumTermLength;
                if (params.maximumResultLength && parseInt(params.maximumResultLength)) config.maxResults = params.maximumResultLength;

                values.suggestVal = ko.observable();
                values.suggestValOptions = params.suggestions;
                values.suggestValThrottled = ko.computed(values.suggestVal).extend({ throttle: 500 });
                values.suggestValThrottled.subscribe(throttledSubscriber);

                controls.input.on("keyup", onKeyup);
                setTimeout(delayed, 250);

                return true;
            } catch (err) {
                err = err instanceof Error ? err : new Error(err);

                console.log("typeahead init threw an error and may not have initialized");
                console.log(err);

                return false;
            }
        },
        update: function (element, valueAccessor, allBindings) {}
    };
});
